// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.keyboard-icon-img {
  width: 200px;
  height: 50px;
    object-fit: contain;
  }

  .keyboard-icon {
    position: fixed;
    z-index: 1 !important;
    bottom: 22px;
    left: -8px;
  }
  @media (max-width: 420px) {
    .keyboard-icon-img {
      width: 65px;
      height: 23px;
      object-fit: contain;
    }
  
    .keyboard-icon {
      position: fixed;
      bottom: 30px;
      left: 20px;
    }
  }
  @media only screen and (min-width: 421px) and (max-width: 740px) {
    .keyboard-icon-img {
      width: 70px;
      height: 25px;
      object-fit: contain;
    }
  
    .keyboard-icon {
      position: fixed;
      bottom: 22px;
      left: -8px;
    }
  }
  @media only screen and (min-width: 741px) and (max-width: 770px) {
    .keyboard-icon-img {
      width: 100px;
      height: 28px;
      object-fit: contain;
    }
  
    .keyboard-icon {
      position: fixed;
      bottom: 22px;
      left: -8px;
    }
  }
  @media only screen and (min-width: 771px) and (max-width: 950px) {
    .keyboard-icon-img {
      width: 140px;
      height: 40px;
      object-fit: contain;
    }
  
    .keyboard-icon {
      position: fixed;
      bottom: 22px;
      left: -8px;
    }
  }
  @media only screen and (min-width: 951px) and (max-width: 1258px) {
    .keyboard-icon-img {
      width: 140px;
      height: 40px;
      object-fit: contain;
    }
  
    .keyboard-icon {
      position: fixed;
      bottom: 22px;
      left: -8px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/ui/KeyboardIcon/keyboard-icon.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,YAAY;IACV,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,UAAU;EACZ;EACA;IACE;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,UAAU;IACZ;EACF;EACA;IACE;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,UAAU;IACZ;EACF;EACA;IACE;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,UAAU;IACZ;EACF;EACA;IACE;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,UAAU;IACZ;EACF;EACA;IACE;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,UAAU;IACZ;EACF","sourcesContent":["\n.keyboard-icon-img {\n  width: 200px;\n  height: 50px;\n    object-fit: contain;\n  }\n\n  .keyboard-icon {\n    position: fixed;\n    z-index: 1 !important;\n    bottom: 22px;\n    left: -8px;\n  }\n  @media (max-width: 420px) {\n    .keyboard-icon-img {\n      width: 65px;\n      height: 23px;\n      object-fit: contain;\n    }\n  \n    .keyboard-icon {\n      position: fixed;\n      bottom: 30px;\n      left: 20px;\n    }\n  }\n  @media only screen and (min-width: 421px) and (max-width: 740px) {\n    .keyboard-icon-img {\n      width: 70px;\n      height: 25px;\n      object-fit: contain;\n    }\n  \n    .keyboard-icon {\n      position: fixed;\n      bottom: 22px;\n      left: -8px;\n    }\n  }\n  @media only screen and (min-width: 741px) and (max-width: 770px) {\n    .keyboard-icon-img {\n      width: 100px;\n      height: 28px;\n      object-fit: contain;\n    }\n  \n    .keyboard-icon {\n      position: fixed;\n      bottom: 22px;\n      left: -8px;\n    }\n  }\n  @media only screen and (min-width: 771px) and (max-width: 950px) {\n    .keyboard-icon-img {\n      width: 140px;\n      height: 40px;\n      object-fit: contain;\n    }\n  \n    .keyboard-icon {\n      position: fixed;\n      bottom: 22px;\n      left: -8px;\n    }\n  }\n  @media only screen and (min-width: 951px) and (max-width: 1258px) {\n    .keyboard-icon-img {\n      width: 140px;\n      height: 40px;\n      object-fit: contain;\n    }\n  \n    .keyboard-icon {\n      position: fixed;\n      bottom: 22px;\n      left: -8px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
